import { Action } from '@ngrx/store';
import { RoleModel } from '../../models/RoleModel';

export const ADD_ROLE_TO_ROLE_SUCCESS = '[Security] Role Add Role Success';

export class AddRoleToRoleSuccessAction implements Action {
  readonly type = ADD_ROLE_TO_ROLE_SUCCESS;

  constructor(public payload: { roleKey: string, role: RoleModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/AddRoleToRoleSuccessAction.ts